import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  IApiResponse,
  IFilterPaginationDto,
  IOutletDto,
  IOutletFeaturesDto,
  IOutletWorkingHoursDto,
  IOutletWorkingHoursSpecialListDto,
} from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class OutletService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOutletFeatures(id: number): Observable<IOutletFeaturesDto> {
    return this.get(`admin/outlet/features/${id}`);
  }

  public getOutletList(model: IFilterPaginationDto): Observable<IOutletDto[]> {
    return this.post(`admin/outlet/list`, model);
  }

  public getOutletNames(id: number): Observable<KeyValue<number, string>[]> {
    return this.get(`admin/outlet/list/${id}`);
  }

  public getOutlet(id: number): Observable<IOutletDto> {
    return this.get(`admin/outlet/${id}`);
  }

  public saveOutlet(model: IOutletDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/outlet`, model);
  }

  public deleteOutlet(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/outlet/${id}`);
  }

  public changeOutletStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/outlet/${id}`, null);
  }

  public updateOutletOrder(
    model: KeyValue<number, number>[],
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/outlet/order`, model);
  }

  public getOutletWorkingHours(
    id: number,
  ): Observable<IOutletWorkingHoursDto[]> {
    return this.get(`admin/outlet/hours/${id}`);
  }

  public updateOutletWorkingHours(
    id: number,
    model: IOutletWorkingHoursDto[],
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/outlet/hours/${id}`, model);
  }

  public getOutletWorkingSpecialHours(
    id: number,
  ): Observable<IOutletWorkingHoursSpecialListDto[]> {
    return this.get(`admin/outlet/hours/special/${id}`);
  }

  public updateOutletWorkingSpecialHours(
    id: number,
    model: IOutletWorkingHoursSpecialListDto[],
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/outlet/hours/special/${id}`, model);
  }

  public updateOutletFeatures(
    model: IOutletFeaturesDto,
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/outlet/features`, model);
  }
}
